import { useQuery } from 'data-fetching-client';
import { useCallback, useState } from 'react';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import unescapedText from 'I18n/utils/unescapedText';
import { GET_ADMINS, sendAdminEmail } from '../queries/adminQueries';
export function useAdmins() {
  const {
    data: admins = [],
    loading: adminsLoading,
    error: adminsError,
    refetch: refetchAdmins
  } = useQuery(GET_ADMINS, {
    variables: {}
  });
  return {
    admins,
    adminsLoading,
    adminsError,
    refetchAdmins
  };
}
export function useAdminEmail() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const emailAdmin = useCallback(async (adminUserId, listingId, adminInstall = false, permissions = []) => {
    setLoading(true);
    setError(null);
    try {
      await sendAdminEmail(adminUserId, listingId, adminInstall, permissions);
      return {
        success: true
      };
    } catch (err) {
      const errorObj = err instanceof Error ? err : new Error('Failed to send admin email');
      setError(errorObj);

      // Show error alert to user
      FloatingAlertStore.addAlert({
        type: 'danger',
        message: unescapedText('detailsPage.productDetailsCard.cta.error.EMAIL_SEND.message')
      });
      return {
        success: false,
        error: errorObj
      };
    } finally {
      setLoading(false);
    }
  }, []);
  return {
    emailAdmin,
    loading,
    error
  };
}